





































import { Component, Prop, Vue } from "vue-property-decorator";
import { ClientSetupMaster, ClientSetupOptions, ClientSetupProjectOrganisation, ProjectOrganisationApp } from "@/data/models/ClientSetup";
import { EMPTY_VALUE } from "@/utils/ClientAdministrationDetail";
import {
  ClientSetupDraft,
  MAY_BE_NOWHERE,
  PROJECT_ORGANISATION_QUESTIONS,
  followsMaster,
  possibleProjectTypeIds,
  projectOrganisationOptions,
} from "@/utils/ClientSetupDraft";
import { projectOrganisationText, projectSettingsOptionText } from "@/utils/ClientSetupSummary";

@Component
export default class SetupProjectOrganisationStep extends Vue {
  @Prop({ required: true }) draft!: ClientSetupDraft;
  @Prop({ default: null }) options!: ClientSetupOptions | null;
  @Prop({ default: null }) master!: ClientSetupMaster | null;

  questions = PROJECT_ORGANISATION_QUESTIONS;

  get member(): boolean {
    return followsMaster(this.draft);
  }

  get masterName(): string {
    return this.master?.name ?? EMPTY_VALUE;
  }

  /** Without a project product there is nothing to organise; a member always has its master's. */
  get hasProjects(): boolean {
    return this.member || possibleProjectTypeIds(this.options, this.draft.products).length > 0;
  }

  get offered(): ProjectOrganisationApp[] {
    return projectOrganisationOptions(this.draft.products);
  }

  mayBeNowhere(question: keyof ClientSetupProjectOrganisation): boolean {
    return MAY_BE_NOWHERE.includes(question);
  }

  optionText(option: ProjectOrganisationApp): string {
    return projectSettingsOptionText(option, (key) => this.$t(key).toString());
  }

  masterAnswer(question: keyof ClientSetupProjectOrganisation): string {
    const stored = this.master?.projectOrganisation;
    if (!stored) {
      return this.$t("admin.clients.setup.followsMaster").toString();
    }
    return projectOrganisationText(stored[question], (key) => this.$t(key).toString());
  }
}
